<template>
  <header class="topbar">
    <div class="topbar__inner">
      <button
        class="menu"
        type="button"
        aria-label="Ouvrir la navigation"
        @click="$emit('toggle-navigation')"
      >
        <span></span><span></span><span></span>
      </button>
      <p>{{ currentSection }} <span>/</span> {{ currentLabel }}</p>
      <div class="topbar__actions">
        <span class="sync"><i></i> Synchronisé</span
        ><NotificationCenter /><router-link
          to="/parse"
          class="add"
          aria-label="Suivre une annonce"
          ><span aria-hidden="true">＋</span
          ><span class="add__label">Suivre une annonce</span></router-link
        >
      </div>
    </div>
  </header>
</template>
<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
import NotificationCenter from "./NotificationCenter.vue";
export default {
  name: "AppTopbar",
  components: { NotificationCenter },
  emits: ["toggle-navigation"],
  setup() {
    const route = useRoute();
    const currentLabel = computed(
      () => route.meta?.title?.split(" - ")[0] || "Vue d’ensemble",
    );
    // Same groups as the sidebar (route meta.section)
    const currentSection = computed(() => route.meta?.section || "Aujourd’hui");
    return { currentLabel, currentSection };
  },
};
</script>
<style scoped>
.topbar {
  position: sticky;
  top: 0;
  z-index: 30;
  height: calc(64px + var(--safe-top));
  padding-top: var(--safe-top);
  border-bottom: 1px solid #e1e6ed;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(14px);
}
.topbar__inner {
  display: flex;
  height: 100%;
  align-items: center;
  gap: 16px;
  padding: 0 var(--page-gutter);
}
.topbar p {
  margin: 0;
  color: #7b8492;
  font-size: 12px;
  font-weight: 600;
}
.topbar p span {
  margin: 0 6px;
  color: #bcc3cc;
}
.topbar__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}
.sync {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-right: 5px;
  color: #6c7583;
  font-size: 12px;
}
.sync i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22a575;
  box-shadow: 0 0 0 3px #e1f5ed;
}
.bell {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border: 1px solid #dde3e9;
  border-radius: 8px;
  color: #596577;
}
.add {
  display: flex;
  gap: 0.28em;
  height: 38px;
  align-items: center;
  padding: 0 15px;
  border-radius: 8px;
  background: #182235;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}
.menu {
  display: none;
  width: 36px;
  height: 36px;
  padding: 9px;
  border: 1px solid #dde3e9;
  border-radius: 8px;
  background: #fff;
}
.menu span {
  display: block;
  height: 2px;
  margin: 3px 0;
  background: #182235;
}
@media (max-width: 1100px) {
  .topbar__inner {
    padding: 0 var(--page-gutter);
  }
  .menu {
    display: block;
  }
  .topbar p {
    display: none;
  }
}
@media (max-width: 560px) {
  .sync {
    display: none;
  }
  /* Icon only: the label is hidden, the "+" stays */
  .add {
    width: 38px;
    padding: 0;
    justify-content: center;
    font-size: 18px;
  }
  .add__label {
    display: none;
  }
}
</style>
